import { render, staticRenderFns } from "./LostConnection.vue?vue&type=template&id=04726b72&scoped=true&"
import script from "./LostConnection.vue?vue&type=script&lang=js&"
export * from "./LostConnection.vue?vue&type=script&lang=js&"
import style0 from "./LostConnection.vue?vue&type=style&index=0&id=04726b72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04726b72",
  null
  
)

export default component.exports